import { useEffect, useRef, useState } from 'react';
import { milestones } from '../data/siteData';
import Reveal from './Reveal';
import './Milestones.css';

function Milestones() {
  const timelineRef = useRef(null);
  const [lineVisible, setLineVisible] = useState(false);

  useEffect(() => {
    const el = timelineRef.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setLineVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="milestones" className="section milestones">
      <div className="section-inner">
        <Reveal variant="up" className="milestones-heading" as="div">
          <h2>
            Milestones That <span className="accent">Shaped A Legacy</span>
          </h2>
        </Reveal>

        <div className={`timeline ${lineVisible ? 'is-visible' : ''}`} ref={timelineRef}>
          <div className="timeline-line" aria-hidden="true" />
          {milestones.map((m, i) => {
            const isLeft = i % 2 === 0;
            return (
              <div className={`timeline-row ${isLeft ? 'is-left' : 'is-right'}`} key={m.year}>
                <Reveal variant={isLeft ? 'left' : 'right'} delay={i * 70} as="div" className="timeline-card">
                  <div className="timeline-year">{m.year}</div>
                  <p className="timeline-text">{m.text}</p>
                </Reveal>
                <div className="timeline-dot" aria-hidden="true" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Milestones;
